import { render, staticRenderFns } from "./InvoiceDisplayDialog.vue?vue&type=template&id=4567fa10"
import script from "./InvoiceDisplayDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceDisplayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports